// frontend/src/components/comments/CommentComposer.tsx
import React, { useState } from "react";
import { Button, Group, Textarea } from "@mantine/core";

export type CommentComposerProps = {
  /** Called when user submits a non-empty comment */
  onSubmit: (message: string) => void;
  /** Optional initial value (e.g. if you reuse it for editing in the future) */
  initialValue?: string;
  /** Placeholder text in the textarea */
  placeholder?: string;
  /** Disable input + button while external submit is running */
  isSubmitting?: boolean;
};

export const CommentComposer: React.FC<CommentComposerProps> = ({
  onSubmit,
  initialValue = "",
  placeholder = "Skriv en kommentar…",
  isSubmitting = false,
}) => {
  const [value, setValue] = useState(initialValue);

  const handleSubmit = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setValue(""); // clear after successful submit
  };

  return (
    <div>
      <Textarea
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        placeholder={placeholder}
        minRows={2}
        maxRows={4}
        disabled={isSubmitting}
      />
      <Group justify="flex-end" mt="xs">
        <Button
          size="xs"
          onClick={handleSubmit}
          disabled={!value.trim() || isSubmitting}
          loading={isSubmitting}
        >
          Legg til kommentar
        </Button>
      </Group>
    </div>
  );
};
